import { Alert, Button } from 'antd';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { PlusOutlined } from '@ant-design/icons';

import { Carousel, FormWrapper } from '../../../WidgetConfiguratorComponents/FormGroups';
import WarningThresholdSettings from './WarningThresholdSettings';
import { WarningBoxConfigBlockState } from '../types';

const DEFAULT_THRESHOLD_TEXT =
    'Thresholds will be evaluated from top to bottom. The first (if any) threshold to be triggered determines the content in the report. If no threshold is triggered, the summary value will still be shown with no decoration.';
// const DEFAULT_NO_WARNING_THRESHOLD_TEXT = 'No warning threshold assigned';
const COMPARATORS = ['is greater than', 'is less than', 'is greater than or equal to', 'is less than or equal to', 'is exactly equal to', 'is not equal to'];

interface WarningSettingsProps {
    viewblockState: WarningBoxConfigBlockState;
    setViewblockState: React.Dispatch<React.SetStateAction<WarningBoxConfigBlockState>>;
}

export const WarningSettings = ({ viewblockState, setViewblockState }: WarningSettingsProps) => {
    const onAddWarningThreshold = (warningId: string) => {
        setViewblockState((prev) => ({
            ...prev,
            settings: {
                ...prev.settings,
                thresholds: [
                    ...(prev.settings.thresholds ?? []),
                    {
                        color: '#D33115',
                        comparator: COMPARATORS[0],
                        label: COMPARATORS[0],
                        name: 'Warning',
                        value: '2',
                        id: uuidv4(),
                        warningId,
                    },
                ],
            },
        }));
    };

    return (
        <FormWrapper>
            <div
                style={{
                    gridColumn: '1/6',
                    paddingBottom: 10,
                }}
            >
                <Alert message={DEFAULT_THRESHOLD_TEXT} type='info' />
            </div>
            <Carousel label='Warning Threshold Definitions'>
                {viewblockState.settings.warnings &&
                    viewblockState.settings.warnings.map((warning) => {
                        return (
                            <React.Fragment key={`warning-settings-${warning.id}`}>
                                <h4 style={{ gridColumn: '1/3', margin: 0, padding: 0, color: 'white', fontWeight: 'bold' }}>{warning.label}</h4>
                                <Button
                                    style={{ gridColumn: '3/6', margin: 0, padding: 0, textAlign: 'center' }}
                                    icon={<PlusOutlined />}
                                    type='primary'
                                    onClick={() => onAddWarningThreshold(warning.id)}
                                >
                                    Add Threshold
                                </Button>
                                <WarningThresholdSettings
                                    key={`WarningThresholdSettings-${warning.id}`}
                                    warningId={warning.id}
                                    viewblockState={viewblockState}
                                    setViewblockState={setViewblockState}
                                />
                            </React.Fragment>
                        );
                    })}
            </Carousel>
        </FormWrapper>
    );
};
